export class SetAlertFlag {
    public static readonly type = '[MessagingState] Set alert flag';
}
